import BlockAuthor from './block-author';

export default class BlockAuthorDesktop extends BlockAuthor {
    constructor(...args) {
        super(...args);
    }

    /*
    init() {
    }
    bind() {
    }
    unbind() {
    }
    resize(width, height) {
    }
    */
}



// WEBPACK FOOTER //
// ./src/js/components/block-author/block-author.desktop.js